const ChannelConversionStatistics = () =>
  import('@/views/main/wechatMgmt/channelConversionStatistics/ChannelConversionStatistics.vue')
export default {
  path: '/main/wechatMgmt/channelConversionStatistics',
  name: 'ChannelConversionStatistics',
  component: ChannelConversionStatistics
}
